module.exports = __webpack_public_path__ + "images/icons/cards/maestro-8db2ae45.svg";